import type { CSSProperties } from "react";
import { FIND_RIDE_COLORS } from "../constants/findRide.constants";
import {
  FIND_RIDE_BACKGROUND_URL,
  FIND_RIDE_HEADER_OFFSET,
} from "../constants/findRide.assets";

/**
 * Page background only — natural document scroll (no nested scrollport).
 */
export const findRidePageBackgroundStyle: CSSProperties = {
  backgroundImage: `url(${FIND_RIDE_BACKGROUND_URL})`,
  backgroundSize: "cover",
  backgroundPosition: "center right",
  backgroundRepeat: "no-repeat",
  backgroundColor: "#E8F0EA",
  minHeight: `calc(100dvh - ${FIND_RIDE_HEADER_OFFSET})`,
};

/** Shared Tailwind / style tokens for the Find Ride feature. */
export const findRideStyles = {
  pageShell: "relative isolate w-full overflow-x-hidden bg-[#E8F0EA]",
  pageOverlay:
    "pointer-events-none absolute inset-0 -z-10 bg-gradient-to-b from-white/40 via-white/15 to-white/50",
  content:
    "relative z-10 mx-auto flex w-full max-w-xl flex-col gap-4 px-3 py-6 sm:gap-6 sm:px-6 sm:py-10",
  card: "w-full min-w-0 rounded-2xl bg-white p-4 shadow-[0_12px_40px_rgba(26,83,54,0.12)] sm:rounded-3xl sm:p-6 md:p-7",
  fieldLabel:
    "text-[11px] font-semibold uppercase tracking-[0.08em] text-gray-400",
  fieldInput:
    "h-auto min-w-0 rounded-xl border-gray-200 py-3 text-sm shadow-none focus-visible:ring-[#1A5336]/20",
  dateChipRow:
    "mt-2 flex w-full min-w-0 items-center gap-2",
  dateChipScroll:
    "flex min-w-0 flex-1 gap-2 overflow-x-auto overscroll-x-contain pb-0.5 [scrollbar-width:none] [-webkit-overflow-scrolling:touch] [&::-webkit-scrollbar]:hidden",
  dateChip:
    "shrink-0 rounded-full border px-2.5 py-1.5 text-xs font-medium transition-colors sm:px-3 sm:text-sm",
  primaryCta:
    "flex w-full items-center justify-center gap-2 rounded-xl py-3.5 text-base font-semibold text-white transition-opacity hover:opacity-95 disabled:opacity-70",
  goldOutlineBtn:
    "flex w-full items-center justify-center rounded-xl border-2 bg-white py-3.5 text-base font-bold transition-colors hover:bg-amber-50",
  errorText: "text-sm text-red-600",
  colors: FIND_RIDE_COLORS,
} as const;
